// @ts-nocheck
import React, { Component } from "react";
import formatDate from "includes/formatDate";
import PostsTilesList from "../PostsTilesList/PostsTilesList";
import PostsTable from "../PostsTable/PostsTable";
import "./PostsList.css";

export default class PostsList extends Component {

	constructor(props) {
		super(props);

		this.state = {
			Posts: (props.posts ? props.posts : []),
			Displayed: [],
			DispIndex: 0,
			DispStep: (document.body.clientHeight < 1000 && document.body.clientWidth < 800) ? 10 : 20,
			HasMore: true,
			DispFavs: false,
			DispCats: []
		};
		this.getNextsPosts = this.getNextsPosts.bind(this);
	}

	componentDidMount() {
		this.sortPosts();
		if (this.props.display !== "table") {
			this.getNextsPosts();
		} else {
			this.checkDelayed();
		}
	}

	componentDidUpdate(old_props) {
		let old_posts = old_props.posts;
		let new_posts = this.props.posts;
		let addeds = (new_posts ? new_posts?.filter(o1 => !old_posts.some(o2 => o1.postId === o2.postId)) : []);
		let removed = (old_posts ? old_posts?.filter(o1 => !new_posts.some(o2 => o1.postId === o2.postId)) : []);

		if (old_props.state !== this.props.state || addeds.length || removed.length || old_posts?.length !== new_posts?.length) {
			this.setState({
				...this.state,
				Posts: this.props.posts,
				Displayed: [],
				DispIndex: 0,
				HasMore: true,
				CurPost: false
			}, () => {
				this.sortPosts();
				if (this.props.display !== "table") {
					this.getNextsPosts();
				} else {
					this.checkDelayed();
				}
			});
		}
	}

	checkDelayed() {
		const posts = this.state.Posts;
		const items = [];
		posts.forEach((post) => {
			if (this.checkDate(post) && this.checkState(post) && this.checkSite(post)) {
				items.push(post);
			}
		});

		this.setState({
			Displayed: this.state.Displayed.concat(items)
		});

	}

	sortPosts(sort_by, asc_order) {
		if (!sort_by)
			sort_by = "priorityTo";
		let posts = this.state.Posts.sort((a, b) => {
			if (a[sort_by] < b[sort_by])
				return ((asc_order ? -1 : 1));
			return ((asc_order ? 1 : -1));
		});
		this.setState({
			Posts: posts
		});
	}

	checkState(post) {
		let curDispState = this.props.state;

		if ((!this.props?.typeId || (post.postTypeId === this.props.typeId))
			&& ((curDispState === "waiting" && post.validationModeration === false && post.draft === false && !post.validationModeration)
				|| (curDispState === "moderated" && post.moderationComment && post.validationModeration === false && post.draft === true)
				|| (curDispState === "published" && post.validationModeration === true && post.draft === false)
				|| (curDispState === "drafts" && post.draft === true && !post.moderationComment && !post.validationModeration))
		)
			return (true);
		return (false);
	}

	checkDate(post) {
		let date = formatDate();
		return (date >= post.publishedDate || this.props.state !== "published" || this.props.isAdmin || post.employeeId === this.props.account?.employeeId);
	}

	checkSite(post) {
		let siteId = this.state.CurSite?.value;
		if (siteId)
			if (post.siteId !== siteId)
				return (false);
		return (true);
	}

	getNextsPosts(max_limit) {
		const { Posts, DispIndex, DispStep, Displayed } = this.state;
		let disp_count = 0;
		let total_count = 0;
		const items = [];
		const postsLength = Posts.length;

		for (let x = DispIndex; x < postsLength && disp_count < DispStep && (!max_limit || disp_count < max_limit); x++) {
			total_count++;
			const post = Posts[x];
			if (this.checkDate(post) && this.checkState(post) && this.checkSite(post)) {
				disp_count++;
				items.push(post);
			}
		}

		const newDispIndex = DispIndex + total_count;
		const hasMore = (!max_limit && disp_count < DispStep) ? false : true;

		this.setState({
			Displayed: [...Displayed, ...items],
			DispIndex: newDispIndex,
			HasMore: hasMore,
		});

		return items;
	}

	render() {
		let childProps = {
			curPost: this.props.curPost,
			displayed: this.state.Displayed,
			hasMore: this.state.HasMore,
			handlePostClick: this.props.handlePostClick,
			getNextItems: this.getNextsPosts,
			dispCats: this.props.dispCats,
			saveds: this.props.Saveds,
			search: this.props.search,
			state: this.props.state,
			typeId: this.props.typeId,
			checkbox: this.props.checkbox,
			items: this.state.Posts
		};

		return (
			<div className={"PostsList d-flex h-100"}>
				{
					this.props.display === "table" ?
						<PostsTable setSelected={this.props.setSelected} itemsLength={this.state.Displayed?.length} {...childProps} />
						:
						<PostsTilesList itemsLength={this.state.Displayed?.length} {...childProps} />
				}
			</div>
		);
	}
}
